import { z } from 'zod';

import {
  BorrowerRequestedPayoffSettings,
  DEFAULT_BORROWER_REQUESTED_PAYOFF_SETTINGS,
  DEV_BORROWER_REQUESTED_PAYOFF_SETTINGS,
} from './BorrowerRequestedPayoffSettings';

export const DEFAULT_GRACE_PERIOD = 15;
export const DEFAULT_PAST_DUE_CADENCE = [1, 3];
export const DEFAULT_LOAN_IS_MATURING_CADENCE = [45];
export const DEFAULT_BORROWER_INSURANCE_EXPIRING_CADENCE = [30, 15];
export const DEFAULT_BORROWER_INSURANCE_EXPIRED_CADENCE = [5, 30];

export const DEFAULT_LOAN_CONTROL_SETTINGS: CompanyLoanControlSettings = {
  loanNoteCategoriesRequired: false,
  preActiveWelcomeEnabled: false,
  pastGraceEmailEnabled: false,
  pastGracePeriodDays: DEFAULT_GRACE_PERIOD,
  pastDueNotificationCadence: DEFAULT_PAST_DUE_CADENCE,
  loanIsMaturingNotificationCadence: DEFAULT_LOAN_IS_MATURING_CADENCE,
  borrowerInsuranceExpiringNotificationCadence: DEFAULT_BORROWER_INSURANCE_EXPIRING_CADENCE,
  borrowerInsuranceExpiredNotificationCadence: DEFAULT_BORROWER_INSURANCE_EXPIRED_CADENCE,
  allowTransferDateAnyDayOfMonth: false,
  borrowerRequestedPayoffSettings: DEFAULT_BORROWER_REQUESTED_PAYOFF_SETTINGS,
};

export const DEV_LOAN_CONTROL_SETTINGS: CompanyLoanControlSettings = {
  ...DEFAULT_LOAN_CONTROL_SETTINGS,
  allowTransferDateAnyDayOfMonth: true,
  borrowerRequestedPayoffSettings: DEV_BORROWER_REQUESTED_PAYOFF_SETTINGS,
};

export const CompanyLoanControlSettings = z.object({
  // loan notes
  loanNoteCategoriesRequired: z.boolean(),

  // general notifications
  preActiveWelcomeEnabled: z.boolean(),
  pastGraceEmailEnabled: z.boolean(),
  pastGracePeriodDays: z.number(),
  pastDueNotificationCadence: z.array(z.number()), // days late
  loanIsMaturingNotificationCadence: z.array(z.number()),

  borrowerInsuranceExpiringNotificationCadence: z
    .array(z.number())
    .default(DEFAULT_BORROWER_INSURANCE_EXPIRING_CADENCE),
  borrowerInsuranceExpiredNotificationCadence: z.array(z.number()).default(DEFAULT_BORROWER_INSURANCE_EXPIRED_CADENCE),

  // servicing transfer
  showTransferDateOnBusinessDay: z.boolean().optional(), // TODO: Remove this after next deploy (12/9/24)
  allowTransferDateAnyDayOfMonth: z.boolean().optional(),

  // payoffs
  borrowerRequestedPayoffSettings: BorrowerRequestedPayoffSettings,
});
export type CompanyLoanControlSettings = z.infer<typeof CompanyLoanControlSettings>;
